module.exports = __webpack_public_path__ + "static/media/参与投票@2x.8c41d564.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_209/images/参与投票@2x.png
// module id = 1732
// module chunks = 0